<ym-modal (onClose)="toggleModal()">
    <ng-container header>
        <div class="ym-display-flex ym-gap-3 ym-justify-content-center ym-align-items-center">
            <span class="icon ym-svg-md">
                <ym-icon [iconName]="iconNames.FILTER"></ym-icon>
            </span>
            Filter
        </div>
    </ng-container>
    <ng-container body>
        <div class="main-content ym-display-flex ym-flex-direction-column ym-h-full ym-gap-5 ym-mb-5">
            <app-field-selection-dropdown [label]="selectedField ? selectedField.label : 'Select field'"
                [canMultiSelect]="false" [allFields]="fieldDocuments" [allGroups]="fieldGroups"
                [selectedFields]="selectedField ? [selectedField.name] : []" (valueChange)="updateSelectedField($event)"
                [fullWidth]="true">
            </app-field-selection-dropdown>

            <div class="input-main-container ym-display-flex ym-flex-direction-column ym-gap-2">
                <div class="label-container ym-display-flex ym-align-items-center ym-gap-3">
                    <div class="ym-text-color ym-display-flex ym-align-items-center ym-gap-2 ym-w-full">
                        <span class="text ym-font-base ym-line-height-normal">Sorting order:</span>
                    </div>
                </div>
                <div class="radio-group ym-display-flex ym-flex-direction-column ym-gap-3">
                    <ym-radio [checked]="sortOrders.ASC === activeSortOrder" [label]="'Ascending (low to high)'"
                        [name]="'ascending'" (onClick)="toggleActiveSorting(sortOrders.ASC)"></ym-radio>
                    <ym-radio [checked]="sortOrders.DESC === activeSortOrder" [label]="'Descending (high to low)'"
                        [name]="'descending'" (onClick)="toggleActiveSorting(sortOrders.DESC)"></ym-radio>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-container actions>
        <!-- <ym-button [loading]="isLoading" (onClick)="saveFilter()">
            Reset to default
        </ym-button> -->
        <ym-button [type]="buttonTypes.PRIMARY" [loading]="isLoading" (onClick)="saveFilter()">
            Apply
        </ym-button>
    </ng-container>
</ym-modal>